import gql from 'graphql-tag';

/**
 * Data of the block project-measurement-report-verification ("Aufmaßprotokoll: Prüfung"): the AC
 * and DC verification states and the deprecated overall state. Read through
 * `Project.blocks.measurementReportVerification`, which checks the block's read permission.
 */
export const PROJECT_MEASUREMENT_REPORT_VERIFICATION_FIELDS = gql`
  fragment projectMeasurementReportVerificationFields on ProjectMeasurementReportVerificationBlock {
    id
    number
    measurementAcVerificationState
    measurementDcVerificationState
    measurementVerificationState
  }
`;
